import React from 'react'
import styled from 'styled-components'
import { Message as MessageType } from '../types'
import { User } from '../../auth/types'
import colors from '../../../constants/colors'
import UserThumbnail from './UserThumbnail'
import { formatTimeAgo } from '../../../utils/datetime'
import useInterval from '../../../hooks/useInterval'

interface IsSentProps {
    isSent: boolean
}

interface MessageProps {
    isSent: boolean
    message: MessageType
    sender: User
}

const getChatBackgroundColor = ({ isSent }: IsSentProps) => (!isSent
    ? colors.gray4
    : colors.info)

const getChatColor = ({ isSent }: IsSentProps) => (!isSent
    ? colors.gray9
    : colors.gray1)

const getJustifyText = ({ isSent }: IsSentProps) => (!isSent
    ? 'flex-start'
    : 'flex-end')

const getFlexDirection = ({ isSent }: IsSentProps) => (!isSent
    ? 'row'
    : 'row-reverse')

const S = {
    Message: styled.div<IsSentProps>`
        min-height: 68px; // Fix bug can't scroll bottom on safari
        flex-direction: ${getFlexDirection};
        margin: 8px 16px;
        display: flex;
        align-items: start;
    `,

    MessageInner: styled.div<IsSentProps>`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: ${getJustifyText};
        margin-left: 8px;
        margin-right: 8px;
    `,

    TextBox: styled.div<IsSentProps>`
        background-color: ${getChatBackgroundColor};
        color: ${getChatColor};
        justify-content: ${getJustifyText};
        display: flex;
        padding: 12px;
        font-size: 14px;
        border-radius: 4px;
        width: 100%;
        white-space: normal;
    `,

    Date: styled.div<IsSentProps>`
        color: ${colors.gray5};
        font-size: 12px;
        justify-content: ${getJustifyText};
        display: flex;
        flex-grow: 1;
        padding: 3px 8px;
        width: 100%;
    `,
}

const Message = ({ message, sender, isSent }: MessageProps) => {
    useInterval(1000 * 60) // To re-render this component every minute
    return (
        <S.Message isSent={isSent}>
            <UserThumbnail src={sender?.mugshot} alt="" />
            <S.MessageInner isSent={isSent}>
                <S.TextBox isSent={isSent}>{message.text}</S.TextBox>
                <S.Date isSent={isSent}>
                    {formatTimeAgo(message.sent_at)}
                </S.Date>
            </S.MessageInner>
        </S.Message>
    )
}

export default Message
